import React from "react";
import { NavLink } from "react-router-dom";

export default function Advertisement() {
  return (
    <div className={"ads-restaurant-frame"}>
      <div className={"ads-copy"}>
        <span>Weekend reading</span>
        <h2>Build your personal library with books that stay with you.</h2>
        <p>
          Browse timeless classics, self-development titles, and new releases in
          a calm bookstore experience.
        </p>
        <div className={"ads-points"}>
          <strong>24K+</strong>
          <small>happy readers</small>
          <strong>320+</strong>
          <small>curated titles</small>
        </div>
        <NavLink to="/products">Explore collection</NavLink>
      </div>
      <div className={"ads-video-wrap"}>
        <div className={"ads-floating-card top"}>Editor’s weekend pick</div>
        <div className={"ads-floating-card bottom"}>Fresh shelves every week</div>
        <video
          className={"ads-video"}
          autoPlay={true}
          loop
          muted
          playsInline
          data-video-media=""
        >
          <source type="video/mp4" src="video/book-ads.mp4" />
        </video>
      </div>
    </div>
  );
}
